import { useAuth } from '@flipster/features/src/shared/auth/state';
import { T } from '@flipster/i18n';
import { Checkbox } from '@flipster/react/design-system/checkbox';
import { Dialog } from '@flipster/react/design-system/dialog';
import { dialog } from '@flipster/react/design-system/dialog/layout';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';
import { getFlipsterConfigsV1Key, getLocalStorage, setLocalStorage } from '@flipster/utils/localStorage';

export function useOpenConfirmDialog() {
  const { user } = useAuth();
  const storageKey = user && getFlipsterConfigsV1Key(user.userId, 'skipAdjustLeverageDialog');

  return () => {
    const skipDialog = storageKey && Boolean(getLocalStorage(storageKey));
    if (skipDialog) return Promise.resolve();

    let isChecked = false;
    return dialog.open<void>(({ isOpen, unmount, promise }) => (
      <Dialog.Root isOpen={isOpen} onExit={unmount}>
        <Dialog.Title label={<T id='Position_leverage.r260311.Adjust_leverage_confirm_title' />} />
        <Dialog.Content>
          <div className={stack({ gap: 24 })}>
            <div className={css({ textStyle: 'Text/L/Regular', color: 'content.default.level-3' })}>
              <T id='Position_leverage.r260311.Adjust_leverage_confirm_description' />
            </div>
            <Checkbox onChange={(e) => (isChecked = e.target.checked)} css={{ color: 'content.default.level-5' }}>
              <T id='Common.r251204.Don_t_show_message_again' />
            </Checkbox>
          </div>
        </Dialog.Content>
        <Dialog.Footer direction='vertical'>
          <Dialog.Button
            hierarchy='secondary'
            color='neutral'
            label={<T id='Common.r250401.Cancel' />}
            onClick={() => promise.reject()}
          />
          <Dialog.Button
            hierarchy='primary'
            label={<T id='Position_leverage.r260311.Adjust_leverage_confirm_cta_primary' />}
            onClick={() => {
              if (isChecked && storageKey) setLocalStorage(storageKey, true);
              promise.resolve();
            }}
          />
        </Dialog.Footer>
      </Dialog.Root>
    ));
  };
}
